import {NgModule} from '@angular/core';
import {BrowserModule, Title} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SearchUserModule} from "./@modules/+search-user/search-user.module";
import {SharedModule} from "./@shared/shared.module";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AuthModule} from "./@core/auth/auth.module";
import {AuthGuardService} from "./@core/guards/auth-guard.service";
import {AuthUserService} from "./@shared/services/auth/auth-user.service";
import {JwtService} from "./@core/auth/jwt.service";
import {AuthInterceptor} from "./@core/auth/auth.interceptor";
import {HeaderModule} from "./@shared/header/header.module";
import {StartPageModule} from "./@modules/+start-page/start-page.module";
import {MatDialogModule} from "@angular/material/dialog";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {NGX_MAT_DATE_FORMATS, NgxMatDateAdapter, NgxMatDateFormats} from "@angular-material-components/datetime-picker";
import {NgxMatMomentAdapter} from "@angular-material-components/moment-adapter";

const MY_NGX_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: "l, LTS"
  },
  display: {
    dateInput: "DD.MM.yyyy HH:mm",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SearchUserModule,
    AuthModule,
    HeaderModule,
    StartPageModule,
    SharedModule,
    MatDialogModule,
  ],
  providers: [
    AuthGuardService,
    AuthUserService,
    JwtService,
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },

    {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
    {
      provide: NgxMatDateAdapter,
      useClass: NgxMatMomentAdapter, //Moment adapter
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: NGX_MAT_DATE_FORMATS, useValue: MY_NGX_DATE_FORMATS}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
